/*
 * Common classes for use in BeTable and the other display types
 */

export type BeIcon = {
	mini?: string;
	large?: string;
};

export type BeItemTextDecoration = "none" | "underline";

export type BeItem = {
	id: string;
	/** A bare string is the mini URL. */
	icon?: string | BeIcon;
	decoration?: BeItemTextDecoration;
};

/** Falls back to the size the item does carry, so a one-size item still draws. */
export function beIconSrc(icon: string | BeIcon | undefined, size: keyof BeIcon): string | undefined {
	if (icon === undefined) return undefined;
	if (typeof icon === "string") return icon;
	return icon[size] ?? icon[size === "mini" ? "large" : "mini"];
}
